import React, { ChangeEvent, useContext, useEffect } from "react";
import OwButton from "../../../shared/OwButton/OwButton";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import IQBDReconcileSalesOrdersDTO from "../../../../models/DTO/IQBDReconcileSalesOrdersDTO";
import { SocketContext } from "../../../../contexts/SocketContext";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";
import IUiSocketSetup from "../../../../models/IUiSocketSetup";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IQBDOnGetQueueItemsByTypeDTO from "../../../../models/DTO/IQBDOnGetQueueItemsByTypeDTO";
import IQBDGetQueueItemsByTypeDTO from "../../../../models/DTO/IQBDGetQueueItemsByTypeDTO";
import QBDQueueTypeEnum from "../../../../models/QBDQueueTypeEnum";
import QBDQueueActionEnum from "../../../../models/QBDQueueActionEnum";
import OwLabel from "../../../shared/OwLabel/OwLabel";

type Props = {
    closeModalFn: () => void;
    startFn: (initPayload: Partial<IQBDReconcileSalesOrdersDTO>) => void;
};

export const QbdReconcileSalesOrdersModal = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const socket = useContext(SocketContext)!;

    const [createOrderIfNotFound, setCreateOrderIfNotFound] = React.useState<boolean>(false);
    const [hasNecessaryQueueItems, setHasNecessaryQueueItems] = React.useState<boolean>(false);
    const [isLoading, setIsLoading] = React.useState<boolean>(true);

    const getQueueItemsByType = () => {
        const payload: IQBDGetQueueItemsByTypeDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            queueType: QBDQueueTypeEnum.READ,
            queueAction: QBDQueueActionEnum.READ_SALES_ORDERS,
            onlyCount: true,
            onlyNotHasProcessed: true,
        };

        socket.emit(EndpointsEnum.QBDGetQueueItemsByType, payload);
    };

    const onGetQueueItemsByType = (data: IQBDOnGetQueueItemsByTypeDTO) => {
        if (data.count) {
            setHasNecessaryQueueItems(true);
        }

        setIsLoading(false);
    };

    const sockets: IUiSocketSetup[] = [{ endpoint: EndpointsEnum.QBDOnGetQueueItemsByType, fn: onGetQueueItemsByType }];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        getQueueItemsByType();

        return () => {
            for (const _socket of sockets) {
                socket.off(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        switch (name) {
            case "create_order_if_not_found":
                setCreateOrderIfNotFound(value);
                break;
        }
    };

    const startFn = () => {
        const payload: Partial<IQBDReconcileSalesOrdersDTO> = {
            createOrderIfNotFound,
        };

        props.startFn(payload);
    };

    return (
        <div className={"QbdReconcileSalesOrdersModal p-2"}>
            <div className={"d-flex justify-content-between align-items-center"}>
                <OwTitle title={"reconcile_sales_orders"} tag={"h2"} />
                <div>
                    <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={props.closeModalFn}></OwButton>
                </div>
            </div>
            {isLoading ? (
                <div>
                    <OwLabel title={"loading"} leftIconClass={"fas fa-spin fa-refresh"} />
                </div>
            ) : (
                <div>
                    {hasNecessaryQueueItems ? (
                        <div>
                            <div className="mt-2">
                                <OwCheckbox
                                    label={"create_order_if_not_found"}
                                    name={"create_order_if_not_found"}
                                    checked={createOrderIfNotFound}
                                    fn={handleChange}
                                    truthyVal={true}
                                    falsyVal={false}
                                />
                            </div>
                            <div className="mt-2">
                                <OwButton title={"start"} fn={startFn} />
                            </div>
                        </div>
                    ) : (
                        <div>
                            <OwLabel title={"no_unprocessed_sales_orders_pull_more"} leftIconClass={"fad fa-circle-info text-info"} />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};
